import { render } from "./ComputerLabs.vue?vue&type=template&id=0ba77d8e&scoped=true"
import script from "./ComputerLabs.vue?vue&type=script&lang=js"
export * from "./ComputerLabs.vue?vue&type=script&lang=js"

import "./ComputerLabs.vue?vue&type=style&index=0&id=0ba77d8e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ba77d8e"

export default script